export default __webpack_public_path__ + "static/media/zeste-logo-menu-8x.37f2c258.png";